module.exports = __webpack_public_path__ + "static/media/filter-icon-2-normal.a0c40938.svg";